@if (forms(); as forms) {
  <div
    *ngrxLet="service.safeUrl$ as safeUrl"
    class="flex flex-1 flex-col gap-2"
  >
    @if (showHeader()) {
      <div
        class="flex items-center rounded-sm bg-white p-2"
        [ngClass]="{
          'justify-start': !immutable() && forms.length === 1,
          'justify-between': !immutable() && forms.length > 1,
          'justify-end': immutable() && forms.length > 1
        }"
      >
        @if (!immutable()) {
          <div class="flex gap-2">
            <button mat-stroked-button (click)="service.downloadForm()">
              Download & Edit
            </button>
            <pt-loader-button
              *ngrxLet="service.uploading() as uploading"
              type="stroked"
              [loading]="uploading"
              [disabled]="service.uploadDisabled() || uploading"
              (click)="fileInput.click()"
            >
              Upload
            </pt-loader-button>
          </div>
        }

        @if (forms.length > 1) {
          <mat-button-toggle-group
            [hideSingleSelectionIndicator]="true"
            [value]="service.activeForm()"
            (change)="service.activeForm.set($event.value)"
          >
            @for (form of forms; track form.label) {
              <mat-button-toggle [value]="form">
                {{ form.label | splitCamel | titlecase }}
              </mat-button-toggle>
            }
          </mat-button-toggle-group>
        }
      </div>
    }

    @if (safeUrl) {
      <object
        class="flex-1"
        type="application/pdf"
        width="100%"
        height="100%"
        [data]="safeUrl"
      >
        <p>
          Your browser does not support PDF embedding.<br />
          Please download the PDF to view it:
          <a target="_blank" [href]="safeUrl">Download PDF</a>
        </p>
      </object>
    }
  </div>
}

<input
  #fileInput
  type="file"
  hidden
  accept="application/pdf"
  (change)="service.uploadForm($event, fileInput)"
/>
